/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';

import RouteNames from '../../RouteNames';

import ProfilePhotoError from './ProfilePhotoError';
import PhotoModel from '../../../../models/PhotoModel';
import FileActions from '../../redux/FileActions';
import NavigationActions from '../../redux/NavigationActions';

function mapStateToProps(state, routerProps) {
  const history = routerProps.history;

  return {
    doneWithFile: () => {
      NavigationActions.goBack(history, RouteNames.profile());
    },
    selectFile: (newRawFile) => {
      PhotoModel.createFromRawFile(
        newRawFile,
        false,
        (newPhoto) => {
          if (newPhoto.isDimensionTooSmall()) {
            NavigationActions.replace(history, RouteNames.profilePhotoError());
          } else {
            FileActions.rawPhotoSelected(newPhoto);
            NavigationActions.replace(history, RouteNames.profilePhotoCrop());
          }
        }
      );
    },
  };
}

export default connect(mapStateToProps)(ProfilePhotoError);
